import styles from "@/components/float-notification.module.css";
import globals from "@/globals";
import * as signals from "@/signals";
import { handleKeyboardClick, sleep } from "@/utils";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import { t } from "i18next";
import { JSX, useCallback, useState } from "react";

function FloatNotification(): JSX.Element {
	const [isClosing, setIsClosing] = useState(false);

	const closeNotification = useCallback(async (): Promise<void> => {
		setIsClosing(true);
		await sleep(globals.ANIMATION_WAIT_TIME);
		signals.floatNotificationInfo.value = null;
		setIsClosing(false);
	}, []);

	const handleClick = useCallback((): void => {
		globals.floatNotificationCallbacks.onClick?.();
		void closeNotification();
	}, [closeNotification]);

	const handleClose = useCallback(
		(event: React.MouseEvent): void => {
			event.stopPropagation();
			globals.floatNotificationCallbacks.onClose?.();
			void closeNotification();
		},
		[closeNotification],
	);

	if (!signals.floatNotificationInfo.value) {
		return <></>;
	}
	return (
		<div
			className={clsx(
				styles["float-notification"],
				!isClosing && "slide-in",
				isClosing && "slide-out",
			)}
			onClick={handleClick}
			onKeyDown={handleKeyboardClick(handleClick)}
			role="button"
			tabIndex={0}
		>
			<FontAwesomeIcon icon={faCircleExclamation} />
			<div
				className={clsx(
					styles["content"],
					signals.floatNotificationInfo.value.isFolded &&
						styles["fold"],
				)}
			>
				<h1>{signals.floatNotificationInfo.value.title}</h1>
				<div className={styles["description"]}>
					{signals.floatNotificationInfo.value.text}
				</div>
			</div>
			<button
				onClick={handleClose}
				type="button"
			>
				{t("close")}
			</button>
		</div>
	);
}

export default FloatNotification;
